export const CUSTOM_RANGE = "Custom Range";



// WEBPACK FOOTER //
// ./app/modules/SalesDashboard/constants.js